<script>
export default {
  name: 'MaterialInput',
  props: {
    label: {
      type: String,
    },
    value: {
      default: '',
    },
    name: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '',
    },
    error: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      default: 'text',
    },
    hint: {
      default: null,
    },
  },
  watch: {
    value (newValue) {
      this.inputValue = newValue
    },
  },
  data () {
    return {
      inputValue: this.value,
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    },
  },
}
</script>

<template>
  <md-field :class="{ 'md-invalid': error }">
    <label>{{ label }}</label>
    <md-input v-model="inputValue" :placeholder="placeholder" @input="onInput" :disabled="disabled" :type="type"></md-input>
    <span class="md-error">{{ error }}</span>
    <span v-if="hint" class="md-helper-text">{{ hint }}</span>
  </md-field>
</template>



// WEBPACK FOOTER //
// src/components/Material/MaterialInput.vue